import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { API_AUTHORIZE_USER_URL } from "constants/apiUrls";

import { QueryKey } from "../types/queryKey";
import { AuthorizeParameters } from "../types/authParameters";
import { OktaError } from "../../../types/oktaError/oktaError";

import getApiClient from "lib/apiClient/getApiClient";

type AuthorizeUserResponse = {
  redirectUrl: string;
};

function useGetAuthorizeUrl(
  authorizeParams: AuthorizeParameters,
): UseQueryResult<AuthorizeUserResponse, OktaError> {
  const apiClient = getApiClient();

  return useQuery({
    queryKey: [`${QueryKey}-${authorizeParams.sessionToken}`],
    queryFn: async () => {
      const response = await apiClient(API_AUTHORIZE_USER_URL, {
        method: "POST",
        body: JSON.stringify(authorizeParams),
      });
      const data = await response.json();

      return response.ok ? Promise.resolve(data) : Promise.reject(data);
    },
    retry: false,
  });
}

export default useGetAuthorizeUrl;
